import { toastr } from "react-redux-toastr";
import { PROMO_ACTION_TYPES } from "./actionTypes";
import { promoApi } from "./api";

export const promoActions = {
    applyRequest: (code) => ({
        type: PROMO_ACTION_TYPES.APPLY_REQUEST,
        payload: { code },
    }),

    applySuccess: (data) => ({
        type: PROMO_ACTION_TYPES.APPLY_SUCCESS,
        payload: data,
        meta: { timestamp: Date.now() },
    }),

    applyFailure: (error) => ({
        type: PROMO_ACTION_TYPES.APPLY_FAILURE,
        payload: { error },
        error: true,
    }),

    clearPromo: () => ({
        type: PROMO_ACTION_TYPES.CLEAR_PROMO,
    }),
};

export const applyPromoCode = (code, cartItems) => {
    return async (dispatch, getState) => {
        const state = getState().promo;

        if (state.loading) {
            return;
        }

        if (!code || !code.trim()) {
            toastr.warning('Внимание', 'Введите промокод');
            return;
        }

        if (!cartItems || cartItems.length === 0) {
            toastr.warning('Внимание', 'Корзина пуста');
            return;
        }

        dispatch(promoActions.applyRequest(code.trim()));

        try {
            const result = await promoApi.apply(cartItems, code.trim());

            if (result.success) {
                dispatch(promoActions.applySuccess(result));
                toastr.success('Промокод применён', `Скидка: ${Number(result.discount).toLocaleString()}₽`);
            } else {
                dispatch(promoActions.applyFailure(result.message));
                toastr.warning('Промокод', result.message);
            }

            return result;
        } catch (error) {
            console.error('Promo apply error:', error);
            dispatch(promoActions.applyFailure('Ошибка при проверке промокода'));
            toastr.error('Ошибка', 'Не удалось проверить промокод');
        }
    };
};

export const clearPromoCode = () => {
    return (dispatch) => {
        dispatch(promoActions.clearPromo());
        toastr.info('Промокод', 'Промокод удалён');
    };
};